export default __webpack_public_path__ + "static/media/3.d2a1e9ff.png";